import {connect} from "react-redux";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import AdditionRoom from "./AdditionRoom";
import {getBaseUrlSelector} from "../../../globalState/app/selectros";


let mapStateToProps = (state) => {
    return {
        roomsListFromBd: state.object.rooms,
        baseUrl: getBaseUrlSelector(state),
    }
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {mapDispatchToProps}), withRouter)(AdditionRoom);